// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-all {
  margin: 45px 100px;
}

.field {
  width: 30%;
  height: 55px;
  text-align: right;
}

.item-parent {
  display: flex;
  direction: rtl;
}

.item-fielad {
  margin-right: 2rem;
}

.item-label {
  color: blue;
  margin-right: 10px;
}

.form-all {
  margin: 45px 100px;
}

.titie-port {
  text-align: center;
}

.input_label {
  margin-right: 5px;
  max-width: 230px;
  text-align: right;
  font-family: IRANSans;
  font-size: 0.9rem !important;
  color: black;
  margin-left: 0.5rem;
  border: none;
}

.radio-button {
  margin-left: 20px;
}

.input_label {
  margin-right: 5px;
  max-width: 230px;
  text-align: right;
  font-family: IRANSans;
  font-size: 0.9rem !important;
  color: black;
  margin-left: 0.5rem;
  border: none;
}

.title {
  margin-bottom: 10px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

mat-icon {
  font-size: 26px;
  margin-left: 10px;
}

h1 {
  font-size: 1.5rem;
}

.parent-both {
  display: flex;
  margin: auto;
  padding: 20px;
}

.form-style {
  display: flex;
  flex-flow: wrap;
}

label {
  margin: auto;
  display: contents;
  text-align: center;
}

div {
  font-size: 13px;
}

input.ng-untouched.ng-pristine {
  width: 15rem;
  height: 2rem;
}

.prices.ng-star-inserted {
  display: block;
  text-align: -webkit-right;
}

.prices {
  display: flex;
  justify-content: flex-end;
}

.mat-form-field-flex {
  width: 20rem;
}

.txt-area-box {
  width: 55rem;
  direction: rtl;
  text-align: right;
}

.form-added {
  border-radius: 10px;
  border-color: lightgray !important;
  border: solid;
  border-width: 1px;
  margin: 20px;
}

.images {
  margin: 20px;
}

.input-price {
  margin: 20px;
  width: 70%;
}

.checkbox {
  margin-top: 5%;
}

.input_label {
  color: rgb(0, 0, 0);
  font-size: large;
}

.form-style {
  margin-right: 40px;
}

.image {
  width: 100%;
}

.customer {
  overflow: scroll;
  background-color: white;
}

.response-details {
  display: flex;
  flex-flow: wrap;
}

.response-details {
  border: 1px solid;
  padding: 10px;
  margin-top: 2rem;
  border-radius: 17px;
  border-color: #bea7a7;
  direction: rtl;
}

.button0back {
  boredr-borttom: none !important;
}

.null-response {
  text-align: center;
  display: block;
  margin: auto;
}

.alert-message {
  text-align: right;
  word-spacing: 5px;
  direction: rtl;
}

.images {
  display: flex;
  flex-wrap: wrap;
}

.image-file {
  max-width: 15rem;
  margin: 1rem;
}

label {
  text-align: center;
}

.checkbox {
  margin-top: 5%;
}

span.mat-radio-label-content {
  margin-right: 10px;
}

mat-form-field {
  width: 24rem !important;
}

mat-label {
  color: blue;
}

input {
  color: black !important;
  float: left !important;
}

element.style {
  margin-left: 13px;
}

mat-checkbox {
  margin-left: 10px;
}

img {
  width: 14rem;
  height: 13rem;
}

.box-desc {
  height: 200px;
  overflow: auto;
  border: 1px solid lightgray;
  margin: 16px;
  padding: 20px;
  direction: rtl !important;
}

.txt-area-box {
  overflow: auto;
  width: 100%;
  margin-top: 10px;
}

.change-class {
  color: red !important;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 165px;
  overflow: hidden;
  direction: initial;
}

.mat-grid-tile-content {
  display: flex;
  justify-content: flex-start;
}

button {
  width: 8rem;
}

.title {
  margin-bottom: 10px;
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

mat-icon {
  font-size: 26px;
  margin-left: 10px;
}

h1 {
  font-size: 1.5rem;
}

mat-card.mat-card.mat-focus-indicator.title {
  width: initial;
  height: inherit;
}

.mat-icon.mat-icon.notranslate.material-icons.mat-icon-no-color {
  font-size: 24px !important;
  color: rgba(12, 19, 234, 0.6784313725);
}

.change-card {
  width: 100% !important;
  text-align: center;
  margin: 1rem auto auto;
  padding-bottom: 10px;
}

.example-accordion {
  display: block;
  max-width: 90rem;
}

.example-accordion-item {
  display: block;
  border: solid 1px #ccc;
}

.example-accordion-item + .example-accordion-item {
  border-top: none;
}

.example-accordion-item-header {
  display: flex;
  align-content: center;
  justify-content: space-between;
}

.example-accordion-item-description {
  font-size: 15px;
  color: #999;
}

.example-accordion-item-header,
.example-accordion-item-body {
  padding: 16px;
}

.example-accordion-item-header:hover {
  cursor: pointer;
  background-color: #eee;
}

.example-accordion-item:first-child {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.example-accordion-item:last-child {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.items {
  display: flex;
  direction: rtl;
}

.item-title {
  color: blue;
  font-size: 14px;
  margin-left: 100px;
}

::ng-deep .mat-grid-tile-content {
  justify-content: flex-end !important;
}

.container-style {
  margin-right: 100px;
}

.card-container-div {
  display: flex;
  direction: rtl;
  margin-top: 10px;
}

.card-container {
  height: auto;
}

.container-card {
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 5px;
}

mat-card.mat-mdc-card.mdc-card.card-container.ng-star-inserted {
  width: 20%;
  height: 60px;
  padding: 10px;
  margin-bottom: 17px;
}

.header-text {
  text-align: center;
}

.text-img {
  display: flex;
}

mat-icon.mat-icon.notranslate.material-icons.mat-ligature-font.mat-icon-no-color {
  width: 33px;
  height: 20px;
}

a {
  background-color: white !important;
}

mat-card.mat-mdc-card.mdc-card {
  box-shadow: 10 10 6px rgb(65, 82, 116);
}

button {
  width: 250px;
  margin-left: 10px;
  margin-right: 10px;
}

mat-accordion {
  direction: rtl;
}

.card-img {
  margin-top: 20px;
}

.mat-grid-tile {
  background-color: rgba(128, 128, 128, 0.0901960784);
  height: 15%;
  padding: 5px;
  direction: ltr;
}

.card-img {
  width: 20%;
}`, "",{"version":3,"sources":["webpack://./src/app/features/contracts/view-response/view-response.component.scss","webpack://./../../admin%20project/atramehr-admin/src/app/features/contracts/view-response/view-response.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;ACCF;;ADEA;EACE,UAAA;EACA,YAAA;EACA,iBAAA;ACCF;;ADEA;EACE,aAAA;EACA,cAAA;ACCF;;ADEA;EACE,kBAAA;ACCF;;ADEA;EACE,WAAA;EACA,kBAAA;ACCF;;ADEA;EACE,kBAAA;ACCF;;ADEA;EACE,kBAAA;ACCF;;ADEA;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,4BAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;ACCF;;ADEA;EACE,iBAAA;ACCF;;ADEA;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,4BAAA;EACA,YAAA;EACA,mBAAA;EACA,YAAA;ACCF;;ADEA;EACE,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;ACCF;;ADEA;EACE,eAAA;EACA,iBAAA;ACCF;;ADEA;EACE,iBAAA;ACCF;;ADEA;EACE,aAAA;EACA,YAAA;EACA,aAAA;ACCF;;ADEA;EACE,aAAA;EACA,eAAA;ACCF;;ADEA;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;ACCF;;ADEA;EACE,eAAA;ACCF;;ADEA;EACE,YAAA;EACA,YAAA;ACCF;;ADEA;EACE,cAAA;EACA,yBAAA;ACCF;;ADEA;EACE,aAAA;EACA,yBAAA;ACCF;;ADEA;EACE,YAAA;ACCF;;ADEA;EACE,YAAA;EACA,cAAA;EACA,iBAAA;ACCF;;ADGA;EACE,mBAAA;EACA,kCAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;ACAF;;ADGA;EACE,YAAA;ACAF;;ADGA;EACE,YAAA;EACA,UAAA;ACAF;;ADGA;EACE,cAAA;ACAF;;ADGA;EACE,mBAAA;EACA,gBAAA;ACAF;;ADGA;EACE,kBAAA;ACAF;;ADGA;EACE,WAAA;ACAF;;ADGA;EACE,gBAAA;EACA,uBAAA;ACAF;;ADGA;EACE,aAAA;EACA,eAAA;ACAF;;ADGA;EACE,iBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,cAAA;ACAF;;ADGA;EACE,+BAAA;ACAF;;ADGA;EACE,kBAAA;EACA,cAAA;EACA,YAAA;ACAF;;ADGA;EACE,iBAAA;EACA,iBAAA;EACA,cAAA;ACAF;;ADGA;EACE,aAAA;EACA,eAAA;ACAF;;ADGA;EACE,gBAAA;EACA,YAAA;ACAF;;ADIA;EACE,kBAAA;ACDF;;ADIA;EACE,cAAA;ACDF;;ADIA;EACE,kBAAA;ACDF;;ADIA;EACE,uBAAA;ACDF;;ADIA;EACE,WAAA;ACDF;;ADKA;EACE,uBAAA;EACA,sBAAA;ACFF;;ADKA;EACE,iBAAA;ACFF;;ADKA;EACE,iBAAA;ACFF;;ADKA;EACE,YAAA;EACA,aAAA;ACFF;;ADKA;EACE,aAAA;EACA,cAAA;EACA,2BAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;ACFF;;ADKA;EACE,cAAA;EACA,WAAA;EACA,gBAAA;ACFF;;ADKA;EACE,qBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;ACFF;;ADKA;EACE,aAAA;EACA,2BAAA;ACFF;;ADKA;EACE,WAAA;ACFF;;ADKA;EACE,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;ACFF;;ADKA;EACE,eAAA;EACA,iBAAA;ACFF;;ADKA;EACE,iBAAA;ACFF;;ADKA;EACE,cAAA;EACA,eAAA;ACFF;;ADKA;EACE,0BAAA;EACA,sCAAA;ACFF;;ADKA;EACE,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;ACFF;;ADKA;EACE,cAAA;EACA,gBAAA;ACFF;;ADKA;EACE,cAAA;EACA,sBAAA;ACFF;;ADKA;EACE,gBAAA;ACFF;;ADKA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;ACFF;;ADKA;EACE,eAAA;EACA,WAAA;ACFF;;ADKA;;EAEE,aAAA;ACFF;;ADKA;EACE,eAAA;EACA,sBAAA;ACFF;;ADKA;EACE,2BAAA;EACA,4BAAA;ACFF;;ADKA;EACE,8BAAA;EACA,+BAAA;ACFF;;ADKA;EACE,aAAA;EACA,cAAA;ACFF;;ADKA;EACE,WAAA;EACA,eAAA;EACA,kBAAA;ACFF;;ADKA;EACE,oCAAA;ACFF;;ADKA;EACE,mBAAA;ACFF;;ADKA;EACE,aAAA;EACA,cAAA;EACA,gBAAA;ACFF;;ADKA;EACE,YAAA;ACFF;;ADKA;EACE,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;ACFF;;ADIA;EACE,UAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;ACDF;;ADGA;EACE,kBAAA;ACAF;;ADEA;EACE,aAAA;ACCF;;ADEA;EACE,WAAA;EACA,YAAA;ACCF;;ADEA;EACE,kCAAA;ACCF;;ADCA;EACE,sCAAA;ACEF;;ADAA;EACE,YAAA;EACA,iBAAA;EACA,kBAAA;ACGF;;ADDA;EACE,cAAA;ACIF;;ADFA;EACE,gBAAA;ACKF;;ADHA;EACE,mDAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;ACMF;;ADJA;EACE,UAAA;ACOF","sourcesContent":[".form-all {\r\n  margin: 45px 100px;\r\n}\r\n\r\n.field {\r\n  width: 30%;\r\n  height: 55px;\r\n  text-align: right;\r\n}\r\n\r\n.item-parent {\r\n  display: flex;\r\n  direction: rtl;\r\n}\r\n\r\n.item-fielad {\r\n  margin-right: 2rem;\r\n}\r\n\r\n.item-label {\r\n  color: blue;\r\n  margin-right: 10px;\r\n}\r\n\r\n.form-all {\r\n  margin: 45px 100px;\r\n}\r\n\r\n.titie-port {\r\n  text-align: center;\r\n}\r\n\r\n.input_label {\r\n  margin-right: 5px;\r\n  max-width: 230px;\r\n  text-align: right;\r\n  font-family: IRANSans;\r\n  font-size: 0.9rem !important;\r\n  color: black;\r\n  margin-left: 0.5rem;\r\n  border: none;\r\n}\r\n\r\n.radio-button {\r\n  margin-left: 20px;\r\n}\r\n\r\n.input_label {\r\n  margin-right: 5px;\r\n  max-width: 230px;\r\n  text-align: right;\r\n  font-family: IRANSans;\r\n  font-size: 0.9rem !important;\r\n  color: black;\r\n  margin-left: 0.5rem;\r\n  border: none;\r\n}\r\n\r\n.title {\r\n  margin-bottom: 10px;\r\n  margin-top: 10px;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\nmat-icon {\r\n  font-size: 26px;\r\n  margin-left: 10px;\r\n}\r\n\r\nh1 {\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.parent-both {\r\n  display: flex;\r\n  margin: auto;\r\n  padding: 20px;\r\n}\r\n\r\n.form-style {\r\n  display: flex;\r\n  flex-flow: wrap;\r\n}\r\n\r\nlabel {\r\n  margin: auto;\r\n  display: contents;\r\n  text-align: center;\r\n}\r\n\r\ndiv {\r\n  font-size: 13px;\r\n}\r\n\r\ninput.ng-untouched.ng-pristine {\r\n  width: 15rem;\r\n  height: 2rem;\r\n}\r\n\r\n.prices.ng-star-inserted {\r\n  display: block;\r\n  text-align: -webkit-right;\r\n}\r\n\r\n.prices {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.mat-form-field-flex {\r\n  width: 20rem;\r\n}\r\n\r\n.txt-area-box {\r\n  width: 55rem;\r\n  direction: rtl;\r\n  text-align: right;\r\n\r\n}\r\n\r\n.form-added {\r\n  border-radius: 10px;\r\n  border-color: lightgray !important;\r\n  border: solid;\r\n  border-width: 1px;\r\n  margin: 20px;\r\n}\r\n\r\n.images {\r\n  margin: 20px;\r\n}\r\n\r\n.input-price {\r\n  margin: 20px;\r\n  width: 70%;\r\n}\r\n\r\n.checkbox {\r\n  margin-top: 5%;\r\n}\r\n\r\n.input_label {\r\n  color: rgb(0, 0, 0, 1);\r\n  font-size: large;\r\n}\r\n\r\n.form-style {\r\n  margin-right: 40px;\r\n}\r\n\r\n.image {\r\n  width: 100%;\r\n}\r\n\r\n.customer {\r\n  overflow: scroll;\r\n  background-color: white;\r\n}\r\n\r\n.response-details {\r\n  display: flex;\r\n  flex-flow: wrap;\r\n}\r\n\r\n.response-details {\r\n  border: 1px solid;\r\n  padding: 10px;\r\n  margin-top: 2rem;\r\n  border-radius: 17px;\r\n  border-color: #bea7a7;\r\n  direction: rtl;\r\n}\r\n\r\n.button0back {\r\n  boredr-borttom: none !important;\r\n}\r\n\r\n.null-response {\r\n  text-align: center;\r\n  display: block;\r\n  margin: auto;\r\n}\r\n\r\n.alert-message {\r\n  text-align: right;\r\n  word-spacing: 5px;\r\n  direction: rtl;\r\n}\r\n\r\n.images {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.image-file {\r\n  max-width: 15rem;\r\n  margin: 1rem;\r\n\r\n}\r\n\r\nlabel {\r\n  text-align: center;\r\n}\r\n\r\n.checkbox {\r\n  margin-top: 5%;\r\n}\r\n\r\nspan.mat-radio-label-content {\r\n  margin-right: 10px;\r\n}\r\n\r\nmat-form-field {\r\n  width: 24rem !important;\r\n}\r\n\r\nmat-label {\r\n  color: blue;\r\n\r\n}\r\n\r\ninput {\r\n  color: black !important;\r\n  float: left !important;\r\n}\r\n\r\nelement.style {\r\n  margin-left: 13px;\r\n}\r\n\r\nmat-checkbox {\r\n  margin-left: 10px;\r\n}\r\n\r\nimg {\r\n  width: 14rem;\r\n  height: 13rem;\r\n}\r\n\r\n.box-desc {\r\n  height: 200px;\r\n  overflow: auto;\r\n  border: 1px solid lightgray;\r\n  margin: 16px;\r\n  padding: 20px;\r\n  direction: rtl !important;\r\n}\r\n\r\n.txt-area-box {\r\n  overflow: auto;\r\n  width: 100%;\r\n  margin-top: 10px;\r\n}\r\n\r\n.change-class {\r\n  color: red !important;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n  max-width: 165px;\r\n  overflow: hidden;\r\n  direction: initial;\r\n}\r\n\r\n.mat-grid-tile-content {\r\n  display: flex;\r\n  justify-content: flex-start;\r\n}\r\n\r\nbutton {\r\n  width: 8rem;\r\n}\r\n\r\n.title {\r\n  margin-bottom: 10px;\r\n  margin-top: 10px;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\nmat-icon {\r\n  font-size: 26px;\r\n  margin-left: 10px;\r\n}\r\n\r\nh1 {\r\n  font-size: 1.5rem;\r\n}\r\n\r\nmat-card.mat-card.mat-focus-indicator.title {\r\n  width: initial;\r\n  height: inherit;\r\n}\r\n\r\n.mat-icon.mat-icon.notranslate.material-icons.mat-icon-no-color {\r\n  font-size: 24px !important;\r\n  color: #0c13eaad\r\n}\r\n\r\n.change-card {\r\n  width: 100% !important;\r\n  text-align: center;\r\n  margin: 1rem auto auto;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.example-accordion {\r\n  display: block;\r\n  max-width: 90rem;\r\n}\r\n\r\n.example-accordion-item {\r\n  display: block;\r\n  border: solid 1px #ccc;\r\n}\r\n\r\n.example-accordion-item+.example-accordion-item {\r\n  border-top: none;\r\n}\r\n\r\n.example-accordion-item-header {\r\n  display: flex;\r\n  align-content: center;\r\n  justify-content: space-between;\r\n}\r\n\r\n.example-accordion-item-description {\r\n  font-size: 15px;\r\n  color: #999;\r\n}\r\n\r\n.example-accordion-item-header,\r\n.example-accordion-item-body {\r\n  padding: 16px;\r\n}\r\n\r\n.example-accordion-item-header:hover {\r\n  cursor: pointer;\r\n  background-color: #eee;\r\n}\r\n\r\n.example-accordion-item:first-child {\r\n  border-top-left-radius: 4px;\r\n  border-top-right-radius: 4px;\r\n}\r\n\r\n.example-accordion-item:last-child {\r\n  border-bottom-left-radius: 4px;\r\n  border-bottom-right-radius: 4px;\r\n}\r\n\r\n.items {\r\n  display: flex;\r\n  direction: rtl;\r\n}\r\n\r\n.item-title {\r\n  color: blue;\r\n  font-size: 14px;\r\n  margin-left: 100px;\r\n}\r\n\r\n::ng-deep .mat-grid-tile-content {\r\n  justify-content: flex-end !important;\r\n}\r\n\r\n.container-style {\r\n  margin-right: 100px;\r\n}\r\n\r\n.card-container-div {\r\n  display: flex;\r\n  direction: rtl;\r\n  margin-top: 10px;\r\n}\r\n\r\n.card-container {\r\n  height: auto;\r\n}\r\n\r\n.container-card{\r\n  width: 100%;\r\n  margin-top: 10px;\r\n  margin-bottom: 10px;\r\n  padding: 5px;\r\n}\r\nmat-card.mat-mdc-card.mdc-card.card-container.ng-star-inserted {\r\n  width: 20%;\r\n  height: 60px;\r\n  padding: 10px;\r\n  margin-bottom: 17px;\r\n}\r\n.header-text{\r\n  text-align: center;\r\n}\r\n.text-img {\r\n  display: flex;\r\n}\r\n\r\nmat-icon.mat-icon.notranslate.material-icons.mat-ligature-font.mat-icon-no-color {\r\n  width: 33px;\r\n  height: 20px;\r\n}\r\n\r\na {\r\n  background-color: white !important;\r\n}\r\nmat-card.mat-mdc-card.mdc-card {\r\n  box-shadow: 10 10 6px rgba(65, 82, 116, 11.308);\r\n}\r\nbutton{\r\n  width: 250px;\r\n  margin-left: 10px;\r\n  margin-right: 10px;\r\n}\r\nmat-accordion{\r\n  direction: rtl;\r\n}\r\n.card-img{\r\n  margin-top: 20px;\r\n}\r\n.mat-grid-tile {\r\n  background-color: #80808017;\r\n  height: 15%;\r\n  padding: 5px;\r\n  direction: ltr;\r\n}\r\n.card-img{\r\n  width: 20%;\r\n}",".form-all {\n  margin: 45px 100px;\n}\n\n.field {\n  width: 30%;\n  height: 55px;\n  text-align: right;\n}\n\n.item-parent {\n  display: flex;\n  direction: rtl;\n}\n\n.item-fielad {\n  margin-right: 2rem;\n}\n\n.item-label {\n  color: blue;\n  margin-right: 10px;\n}\n\n.form-all {\n  margin: 45px 100px;\n}\n\n.titie-port {\n  text-align: center;\n}\n\n.input_label {\n  margin-right: 5px;\n  max-width: 230px;\n  text-align: right;\n  font-family: IRANSans;\n  font-size: 0.9rem !important;\n  color: black;\n  margin-left: 0.5rem;\n  border: none;\n}\n\n.radio-button {\n  margin-left: 20px;\n}\n\n.input_label {\n  margin-right: 5px;\n  max-width: 230px;\n  text-align: right;\n  font-family: IRANSans;\n  font-size: 0.9rem !important;\n  color: black;\n  margin-left: 0.5rem;\n  border: none;\n}\n\n.title {\n  margin-bottom: 10px;\n  margin-top: 10px;\n  display: flex;\n  justify-content: center;\n}\n\nmat-icon {\n  font-size: 26px;\n  margin-left: 10px;\n}\n\nh1 {\n  font-size: 1.5rem;\n}\n\n.parent-both {\n  display: flex;\n  margin: auto;\n  padding: 20px;\n}\n\n.form-style {\n  display: flex;\n  flex-flow: wrap;\n}\n\nlabel {\n  margin: auto;\n  display: contents;\n  text-align: center;\n}\n\ndiv {\n  font-size: 13px;\n}\n\ninput.ng-untouched.ng-pristine {\n  width: 15rem;\n  height: 2rem;\n}\n\n.prices.ng-star-inserted {\n  display: block;\n  text-align: -webkit-right;\n}\n\n.prices {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.mat-form-field-flex {\n  width: 20rem;\n}\n\n.txt-area-box {\n  width: 55rem;\n  direction: rtl;\n  text-align: right;\n}\n\n.form-added {\n  border-radius: 10px;\n  border-color: lightgray !important;\n  border: solid;\n  border-width: 1px;\n  margin: 20px;\n}\n\n.images {\n  margin: 20px;\n}\n\n.input-price {\n  margin: 20px;\n  width: 70%;\n}\n\n.checkbox {\n  margin-top: 5%;\n}\n\n.input_label {\n  color: rgb(0, 0, 0);\n  font-size: large;\n}\n\n.form-style {\n  margin-right: 40px;\n}\n\n.image {\n  width: 100%;\n}\n\n.customer {\n  overflow: scroll;\n  background-color: white;\n}\n\n.response-details {\n  display: flex;\n  flex-flow: wrap;\n}\n\n.response-details {\n  border: 1px solid;\n  padding: 10px;\n  margin-top: 2rem;\n  border-radius: 17px;\n  border-color: #bea7a7;\n  direction: rtl;\n}\n\n.button0back {\n  boredr-borttom: none !important;\n}\n\n.null-response {\n  text-align: center;\n  display: block;\n  margin: auto;\n}\n\n.alert-message {\n  text-align: right;\n  word-spacing: 5px;\n  direction: rtl;\n}\n\n.images {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.image-file {\n  max-width: 15rem;\n  margin: 1rem;\n}\n\nlabel {\n  text-align: center;\n}\n\n.checkbox {\n  margin-top: 5%;\n}\n\nspan.mat-radio-label-content {\n  margin-right: 10px;\n}\n\nmat-form-field {\n  width: 24rem !important;\n}\n\nmat-label {\n  color: blue;\n}\n\ninput {\n  color: black !important;\n  float: left !important;\n}\n\nelement.style {\n  margin-left: 13px;\n}\n\nmat-checkbox {\n  margin-left: 10px;\n}\n\nimg {\n  width: 14rem;\n  height: 13rem;\n}\n\n.box-desc {\n  height: 200px;\n  overflow: auto;\n  border: 1px solid lightgray;\n  margin: 16px;\n  padding: 20px;\n  direction: rtl !important;\n}\n\n.txt-area-box {\n  overflow: auto;\n  width: 100%;\n  margin-top: 10px;\n}\n\n.change-class {\n  color: red !important;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  max-width: 165px;\n  overflow: hidden;\n  direction: initial;\n}\n\n.mat-grid-tile-content {\n  display: flex;\n  justify-content: flex-start;\n}\n\nbutton {\n  width: 8rem;\n}\n\n.title {\n  margin-bottom: 10px;\n  margin-top: 10px;\n  display: flex;\n  justify-content: center;\n}\n\nmat-icon {\n  font-size: 26px;\n  margin-left: 10px;\n}\n\nh1 {\n  font-size: 1.5rem;\n}\n\nmat-card.mat-card.mat-focus-indicator.title {\n  width: initial;\n  height: inherit;\n}\n\n.mat-icon.mat-icon.notranslate.material-icons.mat-icon-no-color {\n  font-size: 24px !important;\n  color: rgba(12, 19, 234, 0.6784313725);\n}\n\n.change-card {\n  width: 100% !important;\n  text-align: center;\n  margin: 1rem auto auto;\n  padding-bottom: 10px;\n}\n\n.example-accordion {\n  display: block;\n  max-width: 90rem;\n}\n\n.example-accordion-item {\n  display: block;\n  border: solid 1px #ccc;\n}\n\n.example-accordion-item + .example-accordion-item {\n  border-top: none;\n}\n\n.example-accordion-item-header {\n  display: flex;\n  align-content: center;\n  justify-content: space-between;\n}\n\n.example-accordion-item-description {\n  font-size: 15px;\n  color: #999;\n}\n\n.example-accordion-item-header,\n.example-accordion-item-body {\n  padding: 16px;\n}\n\n.example-accordion-item-header:hover {\n  cursor: pointer;\n  background-color: #eee;\n}\n\n.example-accordion-item:first-child {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n}\n\n.example-accordion-item:last-child {\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n.items {\n  display: flex;\n  direction: rtl;\n}\n\n.item-title {\n  color: blue;\n  font-size: 14px;\n  margin-left: 100px;\n}\n\n::ng-deep .mat-grid-tile-content {\n  justify-content: flex-end !important;\n}\n\n.container-style {\n  margin-right: 100px;\n}\n\n.card-container-div {\n  display: flex;\n  direction: rtl;\n  margin-top: 10px;\n}\n\n.card-container {\n  height: auto;\n}\n\n.container-card {\n  width: 100%;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  padding: 5px;\n}\n\nmat-card.mat-mdc-card.mdc-card.card-container.ng-star-inserted {\n  width: 20%;\n  height: 60px;\n  padding: 10px;\n  margin-bottom: 17px;\n}\n\n.header-text {\n  text-align: center;\n}\n\n.text-img {\n  display: flex;\n}\n\nmat-icon.mat-icon.notranslate.material-icons.mat-ligature-font.mat-icon-no-color {\n  width: 33px;\n  height: 20px;\n}\n\na {\n  background-color: white !important;\n}\n\nmat-card.mat-mdc-card.mdc-card {\n  box-shadow: 10 10 6px rgb(65, 82, 116);\n}\n\nbutton {\n  width: 250px;\n  margin-left: 10px;\n  margin-right: 10px;\n}\n\nmat-accordion {\n  direction: rtl;\n}\n\n.card-img {\n  margin-top: 20px;\n}\n\n.mat-grid-tile {\n  background-color: rgba(128, 128, 128, 0.0901960784);\n  height: 15%;\n  padding: 5px;\n  direction: ltr;\n}\n\n.card-img {\n  width: 20%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
